const customTable = {
  data: () => ({
    sortBy: 'number',
    descending: true,
    page: 1,
    rowsPerPage: [10, 25, 50],
    totalPages: 0,
    first: false,
    last: false,
    filters: null,
  }),
  methods: {
    changeSort(header) {
      if (!header.sortable) return
      if (this.sortBy === header.value) {
        this.descending = !this.descending
      } else {
        this.sortBy = header.value
        this.descending = false
      }
      this.fetchData()
    },
    getSortClass(header) {
      return [
        header.sortable ? 'column sortable' : null,
        this.pagination && this.pagination.descending ? 'desc' : 'asc',
        header.value === this.pagination.sortBy ? 'active' : '',
      ]
    },
  },
}

export default customTable
